import { useQuery } from "@tanstack/react-query";

import { fetcher } from "./fetcher";

export const root = "/integrations/microsoft-graph/event";

export const useMicrosoftGraphEvent = ({ id, userId, enabled = true } = {}) => {
  const query = {
    id: String(id || ""),
    ...(userId ? { user: String(userId) } : {}),
  };

  const queryFn = fetcher.get(root, { query });

  const { data, isLoading, error } = useQuery({
    enabled: Boolean(enabled && id),
    queryFn,
    queryKey: [root, `${id}`, userId ? String(userId) : ""],
  });

  return {
    event: data?.event || null,
    isLoading,
    error,
  };
};
